// extracted by mini-css-extract-plugin
export default {"addToCartControl":"Q0-z","giftCard":"R0-z","btnContainer":"S0-z","cartButton":"T0-z","disabled":"U0-z"};